export class Pais {
    id: string;
    nombre: string;
    codigo: string;
}
